<template lang="pug">
  .card-home
    img.card-home__icon(:src="card.icon" width="35%")
    span.card-home__title.mt-2.white--text(v-html="card.htmlText")
</template>

<script>
export default {
  name: 'card-home',
  props: ['card'],
}
</script>

<style lang="sass" scoped>
@import "@/assets/style/mobileFirst.sass"
@import "@/assets/style/variables.sass"

.card-home
  display: flex
  flex-direction: column
  align-items: center
  background: $primary
  padding: 16px
  border: 2px solid $secondary
  border-radius: 12px
  min-height: 320px
  transition: all .2s ease
  +media-min-xl
    min-height: 340px
  &__icon
    margin: 30px 0
  &__title
    font-weight: bolder
  &:hover
    transform: scale(1.01)
    transition: all .5s ease
    box-shadow: 0px 0px 10px 0px $secondary
</style>